import CSS from 'csstype';
import { useMemo, useRef } from 'react';
import  CategoriesSwiper  from '../../components/badges/CategoriesSwiper';
import { FoodService } from '../../controllers/FoodService';
import FoodCardList from './components/FoodCardList';


const LunchDinnerSection = () => {

    const refs = {
        'Entradas': useRef(null),
        'Sopas': useRef(null),
        'Pastas': useRef(null),
        'Platos fuertes': useRef(null),
        'Postres': useRef(null)
    };


    const categories = [
        {
            nameEs: 'Entradas',
            action: ''
        },
        {
            nameEs: 'Sopas',
            action: ''
        },
        {
            nameEs: 'Pastas',
            action: ''
        },
        {
            nameEs: 'Platos fuertes',
            action: ''
        },
        {
            nameEs: 'Postres',
            action: ''
        }
    ];

    const entradas: any[] = FoodService.getEntradas();

    const renderEntradas = useMemo(() => {
        console.log('render entradas');
        return (<FoodCardList items={entradas} />);
    }, [entradas]);


    const sopas: any[] = FoodService.getSopas();
    const pastas: any[] = FoodService.getPastas();
    const platosfuertes: any[] = FoodService.getPF();
    const postres: any[] = FoodService.getPostres();

    const scrollToSection = (e) => {
        refs[e.text].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    return (
        <>
            <div className='flex justify-start items-start'>
                <img src="/assets/img/icons/clock-icon.svg" alt="Clock icon" />
                <div className='ml-4 flex flex-col'>
                    <span style={timeTextStyles}>
                        12:00 a.m. - 23:00
                    </span>
                    <span className='mt-2' style={hourTextStyles}>
                        Horarios en días de la Semana
                    </span>
                </div>
            </div>

            <br />
            <p>
                Estimado huésped, los tiempos de preparación de elementos son de aproximadamente 30 a 60 minutos dependiendo la demanda.
            </p>
            <br />
            <CategoriesSwiper categories={categories} select={scrollToSection} />

            <div ref={refs['Entradas']} className='mb-4 mt-4' style={typeFoodstyles}>
                Entradas
            </div>

            <div className='w-full'>
                {renderEntradas}
            </div>

            <div ref={refs['Sopas']} className='mb-4 mt-4' style={typeFoodstyles}>
                Sopas
            </div>

            <div className='w-full'>
                <FoodCardList items={sopas} />
            </div>

            <div ref={refs['Pastas']} className='mb-4 mt-4' style={typeFoodstyles}>
                Pastas
            </div>

            <div  className='w-full'>
                <FoodCardList items={pastas} />
            </div>

            <div ref={refs['Platos fuertes']} className='mb-4 mt-4' style={typeFoodstyles}>
                Platos fuertes
            </div>

            <div className='w-full'>
                <FoodCardList items={platosfuertes} />
            </div>

            <div ref={refs['Postres']} className='mb-4 mt-4' style={typeFoodstyles}>
                Postres
            </div>

            <div className='w-full'>
                <FoodCardList items={postres} />
            </div>
        </>
    )
}

const hourTextStyles: CSS.Properties = {
    color: '#67BAAF',
    fontSize: '14px',
    lineHeight: '14px'
}

const timeTextStyles: CSS.Properties = {
    color: '#4B5563'
}

const typeFoodstyles: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}

export default LunchDinnerSection;
